module.exports = __webpack_public_path__ + "static/media/Association of Pathology Chairs Logo.65837ae7.jpeg";